import { GetInfo } from 'ontime-types';

export const ontimePlaceholderInfo: GetInfo = {
  networkInterfaces: [],
  version: '2.0.0',
  serverPort: 4001,
  publicDir: '',
};
